/** E2E mock UID skips Firebase custom-token apply after verify HTTP succeeds. */

export type VerifiedEmailSession = {
  uid: string;
  email: string;
};

function e2eMockUid(env?: Record<string, string | undefined>): string {
  if (env) {
    return (env.NEXT_PUBLIC_E2E_MOCK_UID || '').trim();
  }
  return (process.env.NEXT_PUBLIC_E2E_MOCK_UID || '').trim();
}

export function shouldSkipFirebaseEmailCredentialApply(
  env?: Record<string, string | undefined>,
): boolean {
  return Boolean(e2eMockUid(env));
}

/** Honest E2E session: uid + email only. Not a Firebase User. */
export function e2eVerifiedEmailSession(
  email: string,
  env?: Record<string, string | undefined>,
): VerifiedEmailSession | null {
  const uid = e2eMockUid(env);
  if (!uid) {
    return null;
  }
  return { uid, email: email.trim().toLowerCase() };
}

export { e2eMockUserEmail } from '../lib/e2eMockUser';
